import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function Loader() {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        zIndex: 100,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
